import styled from 'styled-components'
import { themeColor, themeFontSize, themeFontWeight } from '@elparking/components'

export const SelectorElementRounded = styled.div`
    color: ${themeColor('black')};
    font-weight: ${themeFontWeight('regular')};
    font-size: ${themeFontSize('small')};
    border: none;
    border-radius: 50px;
    box-shadow: none;
    cursor: pointer;
`

export const SelectedElementRounded = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${themeColor('main')};
    font-size: ${themeFontSize('small')};
    font-weight: ${themeFontWeight('book')};
    line-height: normal;
    outline: none;
    padding: 0;
`

export const IconPlaceholder = styled.div`
    color: ${themeColor('main')};
    margin-left: 0.2em;
`

export const CustomSelectedElementWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    > :last-child {
        margin-left: 4px;
    }
`
